import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X } from "lucide-react";
import { films } from "../i18n";

const teaserFilm = films.find((f) => f.id === "toto");

export const TeaserSection = ({ t }) => {
  const [open, setOpen] = useState(false);

  return (
    <section className="py-14 sm:py-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <motion.button
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          data-testid="teaser-card-toto"
          onClick={() => setOpen(true)}
          className="group relative block w-full text-left overflow-hidden rounded-sm border border-line bg-cardbg hover:border-brass transition-colors duration-300"
        >
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-10 p-8 sm:p-12">
            <div className="w-20 h-20 rounded-full border border-linestrong flex items-center justify-center shrink-0 group-hover:bg-ink group-hover:border-ink transition-colors duration-300">
              <Play size={26} className="text-ink group-hover:text-paper transition-colors duration-300 ml-1" />
            </div>
            <div className="text-center sm:text-left">
              <h3 className="font-serif text-4xl sm:text-5xl tracking-tight text-ink">{t.fiction.teaserTitle}</h3>
              <p className="text-sm sm:text-base text-ink2 mt-2 max-w-lg">{t.fiction.teaserBody}</p>
            </div>
          </div>
        </motion.button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="film-trailer-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8"
            onClick={() => setOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.94, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.96, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="w-full max-w-4xl"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/60 mb-3">{teaserFilm.title}</p>
              <div className="aspect-video w-full rounded-sm overflow-hidden shadow-2xl bg-black">
                <video className="w-full h-full" src={teaserFilm.video} controls autoPlay playsInline />
              </div>
            </motion.div>
            <button
              data-testid="film-trailer-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
              className="absolute top-6 right-6 w-11 h-11 rounded-full border border-white/30 text-white flex items-center justify-center hover:bg-white/10 transition-colors"
            >
              <X size={18} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
